import { isResampleFilter } from "./ResampleFilter";
import { isResampleFilterPreset } from "./ResampleFilterPreset";
import type {
  ResampleFilterResolver,
  ResampleFilterResolverOptions,
} from "./ResampleFilterResolver";
import type {
  ResampleFilterPresetsPool,
  ResampleFilterPresetsPoolKeyMap,
} from "./ResampleFilterPresetsPool";
import type { ResampleFilterPreset } from "./ResampleFilterPreset";
import type { ResampleFilter } from "./ResampleFilter";
import type { ResampleFilterFactory } from "./ResampleFilterFactory";

/**
 * Base implementation of ResampleFilterResolver interface.
 */
export class BaseResampleFilterResolver implements ResampleFilterResolver {
  /**
   * BaseResampleFilterResolver constructor.
   *
   * @param filterPresetsPool
   * @param filterFactory
   */
  constructor(
    private readonly filterPresetsPool: ResampleFilterPresetsPool,
    private readonly filterFactory: ResampleFilterFactory
  ) {}

  /**
   * @inheritDoc
   */
  resolve(
    filter:
      | keyof ResampleFilterPresetsPoolKeyMap
      | ResampleFilterPreset
      | ResampleFilter,
    options: ResampleFilterResolverOptions = {}
  ): ResampleFilter {
    if (isResampleFilter(filter)) {
      return filter;
    }
    let preset: ResampleFilterPreset;
    if (isResampleFilterPreset(filter)) {
      preset = filter;
    } else {
      preset = this.filterPresetsPool.get(filter);
    }
    const { blur = 1, windowSupport } = preset;
    const { filterBlur = blur, filterWindowSupport = windowSupport } = options;
    return this.filterFactory.create(
      preset.filterFunctionFactory,
      preset.filterFunctionFactoryArgs,
      preset.windowFunctionFactory,
      preset.windowFunctionFactoryArgs,
      preset.support,
      preset.scale,
      filterBlur,
      filterWindowSupport
    );
  }
}
